import throttle from 'lodash/throttle';
var throttleFetch = function (milliseconds) {
    return throttle(function (searchValue, func) {
        func(searchValue);
    }, milliseconds);
};
export default throttleFetch;
//# sourceMappingURL=throttleFetch.js.map